import { useState } from "react";
import { Collapse, Navbar, NavbarToggler, NavbarText, Nav } from "reactstrap";
import { MenuItem } from "./MenuItem";
import { Menu } from "../../../domain/menuOptions";
import { NeedHelp } from "../NeedHelp";
import {
  brand,
  BrandedConfig,
  ENV_BRAND_NWB,
  ENV_BRAND_RBS,
  ENV_BRAND_UBN,
} from "services/envService";

type NavigationProps = {
  selectedMenu: Menu;
  menus: Menu[];
};

export const NEED_HELP_URLS: BrandedConfig = {
  [ENV_BRAND_NWB]:
    "https://www.business.natwest.com/business/support-centre/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html#payg",
  [ENV_BRAND_RBS]:
    "https://www.business.rbs.co.uk/business/support-centre/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html#payg",
  [ENV_BRAND_UBN]:
    "https://digital.ulsterbank.co.uk/business/support/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html",
};

const BRAND = brand();

export const Navigation = (props: NavigationProps) => {
  const { selectedMenu, menus } = props;
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  return (
    <div id="navigation-container">
      <Navbar className="navigation-wrapper" color="light" light expand="md">
        <div className="nav-header">
          <NavbarText className="zb-heading2 nav-heading">
            Manage your loan
          </NavbarText>
          <NavbarToggler className="burger" onClick={toggle}>
            <div id="close-icon" className={isOpen ? "open" : ""}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </NavbarToggler>
        </div>
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto navigation-buttons" navbar>
            {menus.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  selected={selectedMenu === item}
                  item={item}
                />
              );
            })}
          </Nav>
          <div className="need-help-block">
            <div className="need-help">
              <NeedHelp redirectUrl={NEED_HELP_URLS[BRAND]} />
            </div>
          </div>
        </Collapse>
      </Navbar>
    </div>
  );
};
